import CennikService from "./CennikService";
import CennikEditCtrl from "./CennikEditCtrl";
import CennikListCtrl from "./CennikListCtrl";

import PolozkaCennikaListCtrl from "./PolozkaCennika/PolozkaCennikaListCtrl";
import PolozkaCennikaEditCtrl from "./PolozkaCennika/PolozkaCennikaEditCtrl";

import TypPolozkyCennikaListCtrl from "./TypPolozkyCennika/TypPolozkyCennikaListCtrl";
import TypPolozkyCennikaEditCtrl from "./TypPolozkyCennika/TypPolozkyCennikaEditCtrl";
import TypPolozkyCennikaService from "./TypPolozkyCennika/TypPolozkyCennikaService";

import "./style.css";

export default angular.module("energis.cennik", [])
.config(function routes($stateProvider){
  $stateProvider
  .state("cennik-list", {
    url: "/cenniky",
    template: require("./cennik.list.html"),
    controller: CennikListCtrl,
    controllerAs: "ctrl",
    resolve: {
      itemSource: CennikService => CennikService.listSource().wait()
    }
  })
  .state("cennik-edit", {
    url: "/cenniky/{id:int}/edit",
    template: require("./cennik.edit.html"),
    controller: CennikEditCtrl,
    controllerAs: "ctrl",
    resolve: {
      item: ($stateParams, CennikService) => CennikService.get($stateParams.id),
      saveHandler: (CennikService) => (id, item) => CennikService.save(id, item)
    }
  })
  .state("cennik-polozka-list", {
    url: "/cenniky/{id:int}/polozky",
    template: require("./PolozkaCennika/cennik.polozka.list.html"),
    controller: PolozkaCennikaListCtrl,
    controllerAs: "ctrl"
  })
  .state("cennik-polozka-edit", {
    url: "/cenniky/{cennikId:int}/polozky/{polozkaId:int}/edit",
    template: require("./PolozkaCennika/cennik.polozka.edit.html"),
    controller: PolozkaCennikaEditCtrl,
    controllerAs: "ctrl",
    resolve: {
      item: ($stateParams, CennikService) => CennikService.getPolozka($stateParams.cennikId, $stateParams.polozkaId),
      typyPoloziek: (TypPolozkyCennikaService) => TypPolozkyCennikaService.listSource().wait(),
      saveHandler: (CennikService) => (id, item) => CennikService.savePolozka(id, item)
    }
  })
  .state("cennik-typPolozky-list", {
    url: "/typy-poloziek",
    template: require("./TypPolozkyCennika/cennik.typPolozky.list.html"),
    controller: TypPolozkyCennikaListCtrl,
    controllerAs: "ctrl",
    resolve: {
      itemSource: TypPolozkyCennikaService => TypPolozkyCennikaService.listSource().wait()
    }
  })
  .state("cennik-typPolozky-edit", {
    url: "/typy-poloziek/{id:int}/edit",
    template: require("./TypPolozkyCennika/cennik.typPolozky.edit.html"),
    controller: TypPolozkyCennikaEditCtrl,
    controllerAs: "ctrl",
    resolve: {
      item: ($stateParams, TypPolozkyCennikaService) => TypPolozkyCennikaService.get($stateParams.id),
      saveHandler: (TypPolozkyCennikaService) => (id, item) => TypPolozkyCennikaService.save(id, item)
    }
  })
})
.service("CennikService", CennikService)
.service("TypPolozkyCennikaService", TypPolozkyCennikaService)
.name;



// WEBPACK FOOTER //
// ./src/Cennik/index.js